export enum NewWalletStep {
  CREATE_PASSWORD = 'create_password',
  CREATE_SEED_PHRASE = 'create_seed_phrase',
  SET_SEED_PASSPHRASE = 'set_seed_passphrase',
  VERIFY_SEED_PHRASE = 'verify_seed_phrase',
  ADDRESS = 'address',
  SUCCESS = 'success',
  ERROR = 'error',
}
